import mytipss from './tips.vue'
const mytips = {
  install: (Vue) => {
    Vue.component('mytips', mytipss)
  }
}
export default mytips



//////////////////
// WEBPACK FOOTER
// ./src/components/Mytips/index.js
// module id = null
// module chunks = 